export function getDeviceId() {
  let id = localStorage.getItem("pf_device_id");
  if (!id) {
    id =
      (window.crypto && window.crypto.randomUUID && window.crypto.randomUUID()) ||
      `dev_${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
    localStorage.setItem("pf_device_id", id);
  }
  return id;
}
